@if(offer(); as offer){
    
    @if(showImage()){
        @let card_url = (offer.card_url ?? (offer.gallery_urls?.length ? offer.gallery_urls?.at(0) : undefined));
        @if(card_url){
            <img class="card-image" [src]="card_url | bucket:true" [alt]="offer.brand.name + ' Offer'" [fallback]="'images/fallback/offer.webp'"/>
        }
    }

    <!-- LEFT SIDE ICON BUTTONS -->
    <div class="offer-ctas">
        @if(!replaceCta()){
            @if(locked()){
                <button mat-icon-button class="cosmetic">
                    <mat-icon>lock</mat-icon>
                </button>
            } @else {
                <button mat-icon-button>
                    <mat-icon>cloud_{{offer.saved ? 'done' : 'download'}}</mat-icon>
                </button>
            }
        }
        <ng-content select=".custom-ctas"></ng-content>
    </div>

    <!-- OFFER BODY (IMAGE, TITLE, USAGE) -->
    <a [routerLink]="['/brands', offer.brand.slug, 'offers', offer.url]" class="offer-body">
        <img class="offer-brand" [src]="offer.brand.logo_url | bucket" [alt]="offer.brand.name" [title]="offer.brand.name" [fallback]/>
        <div class="offer-text">
            @if(!replaceBody()){
                <h4 class="offer-title" [title]="offer.short_title">{{offer.short_title}}</h4>
                <p class="offer-usage">{{usage()}}</p>
            }
            <ng-content select=".custom-body"></ng-content>
        </div>
    </a>
    <!-- OFFER FOOTER (WEEKDAYS, PEOPLE) -->
    <div class="offer-footer">
        @if(!replaceFooter()){
            <div class="offer-weekdays">
                @for(day of weekdaysAsBitwise; track day.key){
                    <div class="weekday cosmetic" [class.weekday-inactive]="!weekdays().includes(day.value)">
                        {{day.key[0]}}
                    </div>
    
                }
            </div>
            <div class="offer-people">
                @if(offer.people_min || offer.people_max){
                    <div class="people">
                        <mat-icon class="sized" style="--icon-size: 16px;">people</mat-icon>
                        <span class="font-light">{{people()}}</span>
                    </div>
                }
            </div>
            @if(offer.tier_tree?.tiers?.length){
                <div class="offer-loyalty pt-8">
                    <loyalty-card [offer]="offer" [fitted]="true"></loyalty-card>
                </div>
            }
        }
        <ng-content select=".custom-footer"></ng-content>
    </div>
} @else {
    <!-- TODO: SKELETON -->
}

